import React, { useState } from 'react';
import Layout from '../../pages/_layouts/default';

import { useDispatch, useSelector } from 'react-redux';
import { signupRequest } from '../../store/modules/auth/actions'

import Input from '../../components/Input';
import Button from '../../components/Button';
import Title from '../../components/Title';
import * as S from './styled';


const Signup = () => {

  const dispatch= useDispatch();
  const loading = useSelector(state => state.auth.loading);


  
  const [name, setName] = useState("");
  const [cpf, setCpf] = useState("");
  const [pass, setPass] = useState("");
  const [borderName, setBorderName] = useState("#FDCB00");
  const [borderCpf, setBorderCpf] = useState("#FDCB00");
  const [borderPass, setBorderPass] = useState("#FDCB00");

  function validationInput(e, inputType) {


    if (inputType === 'name') {

      const inputLength = e.length;

      if (inputLength <= 5) {
        setBorderName('#CE1717');
      } else {
        setBorderName('#1FA528');
      }
    }

    if (inputType === 'cpf') {

      const inputLength = e.replace(/_/g, '').length;

      if (inputLength >= 3 && inputLength < 14) {
        setBorderCpf('#CE1717');
      } else {
        setBorderCpf('#1FA528');
      }
    }

    if ( inputType === 'password' ) {

      const inputLength = e.length;

      if (inputLength >= 1 && inputLength < 6) {
        setBorderPass('#CE1717');
      } else {
        setBorderPass('#1FA528');
      }
    }
      
  }

  function handleSubmit(e) {
    e.preventDefault();

    dispatch(signupRequest(name.toUpperCase(), cpf, pass))

    setName("");
    setCpf("");
    setPass("");
    setBorderName('#FDCB00');
    setBorderCpf('#FDCB00');
    setBorderPass('#FDCB00');
  }
    
  return (
    <Layout>
      <>
        <Title text="Cadastrar Usuário" />
        <S.FormWrapper>
          <S.Form  onSubmit={ handleSubmit }>

            <Input 
              type="text"
              placeholder="Digite o seu nome"
              label="Nome"
              value={ name }
              method={ e => {
                setName(e.target.value);
                validationInput(e.target.value, 'name');
              }}
              border={ borderName }
            />

            <Input 
              type="text" 
              placeholder="000.000.000-00"
              mask="999.999.999-99" 
              label="Cpf"
              value={ cpf }
              method={ e => {
                setCpf(e.target.value);
                validationInput(e.target.value, 'cpf');
              }}
              border={ borderCpf }
            />

            <Input 
              type="password" 
              placeholder="••••••••"
              label="Senha"
              value={ pass }
              method={ e => {
                setPass(e.target.value);
                validationInput(e.target.value, 'password');
              }}
              border={ borderPass }
            />

            <S.ControlsWrapper>
              <S.Small to="/dashboard">Voltar</S.Small>
              <Button type="submit" text={ loading ? 'Carregando...' : 'Cadastrar' } background="#0B4683"/>
            </S.ControlsWrapper>
          </S.Form>
        </S.FormWrapper>
      </>
    </Layout>
  );
}

export default Signup;